<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Katalog Ürün Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span>
                <strong>Not:</strong>
                Not: Katalog ürünlerini güncelleyebilir ve çeviri ekleyebilirsiniz.
              </span>
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Ürünler">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>ID</th>
                    <th>UZAK ID</th>
                    <th>ÜRÜN ADI</th>
                    <th>KATEGORİ ADI</th>
                    <th>ALT KATEGORİ ADI</th>
                    <th>MARKA ADI</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <th>İŞLEMLER</th>
                  </thead>
                  <draggable
                    v-model="products"
                    class="cursor-move"
                    tag="tbody"
                    @change="outputData"
                  >
                    <tr v-for="product in products" :key="product.id">
                      <td>{{ product.id }}</td>
                      <td>{{ product.remoteId }}</td>
                      <td>{{ product.title }}</td>
                      <td>{{ product.subCategory.category.title }}</td>
                      <td>{{ product.subCategory.title }}</td>
                      <td>{{ product.brand.title }}</td>
                      <td>
                        <b-badge v-if="product.isDraft == false" variant="light-success">
                          Yayında
                        </b-badge>
                        <b-badge v-if="product.isDraft == true" variant="light-warning">
                          Taslakta
                        </b-badge>
                      </td>
                      <td>{{ product.createdAt }}</td>
                      <td>
                        <b-button-group class="float-right mr-2">
                          <b-button
                            v-for="language in languages"
                            :key="language.locale"
                            @click="action(product, language.locale)"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            :variant="
                              product.languages.find(
                                (element) => element == language.locale
                              )
                                ? 'outline-warning'
                                : 'outline-secondary'
                            "
                            :title="
                              product.languages.find(
                                (element) => element == language.locale
                              )
                                ? 'Düzenle'
                                : 'Ekle'
                            "
                          >
                            {{ language.locale.toUpperCase() }}
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>ID</th>
                    <th>UZAK ID</th>
                    <th>ÜRÜN ADI</th>
                    <th>KATEGORİ ADI</th>
                    <th>ALT KATEGORİ ADI</th>
                    <th>MARKA ADI</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <th>İŞLEMLER</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination
                    :value="currentPage"
                    :total-rows="rows"
                    :per-page="limit"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => getCatalogProducts(value, limit)"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BPagination,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BPagination,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      languages: [],
      products: [],
      rows: 100,
      limit: 10,
      currentPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal, oldVal) {
        this.getCatalogProducts(newVal, this.limit);
      },
      deep: true,
    },
  },
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find((element) => element == locale);
      if (translationControl == undefined) {
        this.$router.push({
          path: `/catalog/products/create/translation/${node.id}?targetLocale=${locale}&page=${this.currentPage}`,
        });
      } else {
        this.$router.push({
          path: `/catalog/products/edit/${node.id}?targetLocale=${locale}&page=${this.currentPage}`,
        });
      }
    },
    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {
      Object.entries(this.products).forEach(([key, value]) => {
        let productsOrder = {
          id: value.id,
          order: parseInt(key),
        };
        this.request.push(productsOrder);
      });
      endpoints
        .putCatalogSubCategoriesOrder(
          { catalogSubCategories: this.request },
          this.limit,
          this.currentPage,
          this.$i18n.locale,
          () => {}
        )
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Katalog alt kategori sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCatalogProducts(page, limit) {
      this.currentPage = page;
      endpoints
        .getCatalogProducts(page, limit, this.$i18n.locale, () => {})
        .then((data) => {
          this.products = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
    this.getCatalogProducts(this.currentPage, this.limit);
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
